const check_url = (url_origin: string | URL) => {
    const url = new URL(url_origin);
    if (parseInt(url.port) === 3000) {
        // Development server
        url.hostname = "localhost";
        url.port = "5000";
    }
    return url.toString();
};

export const BASE_URL = check_url(window.location.origin);

export const displayToStored: Record<number, number> = {
    0:0,
    1:1,
    2:2,
    3:3,
    4:4,
    5:5,
    6:6,
    7:7,
    8:8,
    12:9,
    16:10,
    20:11,
    24:12,
    32:13,
    48:14,
    64:15,
};

export const storedToDisplay: Record<number, number> = {
    0:0,
    1:1,
    2:2,
    3:3,
    4:4,
    5:5,
    6:6,
    7:7,
    8:8,
    9:12,
    10:16,
    11:20,
    12:24,
    13:32,
    14:48,
    15:64,
};